// extracted by mini-css-extract-plugin
export default {"content":"style_content__nsuty","itemName":"style_itemName__K1U79"};